// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    pleaseSelect: {
        id: 'recipe-item.please-select',
        defaultMessage: 'Please Select...'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/dropdown/intl.js